export default __webpack_public_path__ + "img/d396809f10306c6209d68dd50d9c6a38.png";